import React from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';
import { Add } from '@mui/icons-material';
import QuestionView from './QuestionView';

import type { CampaignQuestion } from '../types';

interface QuestionListProps {
    questions: CampaignQuestion[];
    onToggleEditMode: () => void;
}

/**
 * Renders a read-only list of questions in view mode
 *
 * @param {QuestionListProps} props
 * @returns {JSX.Element}
 */
const QuestionList: React.FC<QuestionListProps> = (props) => {
    const { questions, onToggleEditMode } = props;

    return (
        <Stack spacing={1} sx={{ mb: 1 }}>
            {questions.length === 0 ? (
                <Box>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                        No questions have been added to this project yet. Add questions to get started.
                    </Typography>
                    <Button variant="outlined" size="medium" startIcon={<Add />} onClick={onToggleEditMode}>
                        Add questions
                    </Button>
                </Box>
            ) : (
                questions.map((question, index) => (
                    <QuestionView key={question.id} question={question} index={index + 1} allQuestions={questions} />
                ))
            )}
        </Stack>
    );
};

export default QuestionList;
